import axios from "axios";

const instance = axios.create({
  baseURL: process.env["REACT_APP_SERVER_URL"],
});

// Add a response interceptor
instance.interceptors.response.use(
  response => {
    // Return JSON data
    if (response.data) {
      return response.data;
    }
    return response;
  },
  error => {
    // Attempt to get the actual error returned from API
    const err =
      (error.response && error.response.data && error.response.data.error) ||
      error;

    return Promise.reject(err); // Propagate rejection back to caller
  },
);

if (process.env["NODE_ENV"] === "development") {
  window["http"] = instance;
}

export default instance;



// WEBPACK FOOTER //
// ./src/helpers/http.ts